import { createSlice } from "@reduxjs/toolkit";

// Initial state
export const bulkUploadItemConditionInitialState = {
  page: 0,
  size: 10,
};

// Slice
const bulkUploadItemConditionSlice = createSlice({
  name: "bulkUploadItemCondition",
  initialState: bulkUploadItemConditionInitialState,
  reducers: {
    // Set page
    setPage: (state, action) => {
      state.page = action.payload;
    },

    // Set size
    setSize: (state, action) => {
      state.size = action.payload;
    },

    // Set both page and size
    setPagination: (state, action) => {
      state.page = action.payload.page;
      state.size = action.payload.size;
    },

    // Reset state
    resetBulkUploadItemCondition: () => bulkUploadItemConditionInitialState,
  },
});

// Export actions
export const { setPage, setSize, setPagination, resetBulkUploadItemCondition } =
  bulkUploadItemConditionSlice.actions;

// Export reducer
export default bulkUploadItemConditionSlice.reducer;
